export default "https://assets.pclncdn.com/web/next-landing/22c021ab/_next/static/images/seattle-ff5921903dc8fa12860caa47339b1999.jpg";